export let CallMethods;
(function (CallMethods) {
  CallMethods["CALL_FROM_BROWSER"] = "CALL_FROM_BROWSER";
  CallMethods["CALL_FROM_PHONE"] = "CALL_FROM_PHONE";
  CallMethods["CALL_FROM_HUBSPOT_APP"] = "CALL_FROM_HUBSPOT_APP";
})(CallMethods || (CallMethods = {}));
export const CALL_FROM_BROWSER = CallMethods.CALL_FROM_BROWSER;
export const CALL_FROM_PHONE = CallMethods.CALL_FROM_PHONE;
export const CALL_FROM_HUBSPOT_APP = CallMethods.CALL_FROM_HUBSPOT_APP;